import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect } from "react";
import { requestType, requestTypeForUpdate } from "utils/optionData/utils";

const RequsetTypeDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
  disabledDropdown,
  update,
}) => {
  const Options = update
    ? requestTypeForUpdate
    : requestType.map((data) => ({
        id: data.id,
        label: data.label,
      }));

  const handleDropdownChange = (value) => {
    const selectedOption = Options.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      options={Options}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={disabled}
      width="100%"
      dropdowType={name}
      placeholder="Select Request Type"
      height="32px"
      disabledDropdown={disabledDropdown}
    />
  );
};

export default RequsetTypeDropdown;
